/**
 * region for libraries*/
import React, { Component } from 'react';

/**
 * region for helpers*/
import typing from '../../../../helpers/typing';

export class Row extends Component {
    static displayName = Row.name;

    constructor(props) {
        super(props);
        this.state = {
            row: this.props.row
        };

        this.MAXITEMSSHOWED = 2;

    }

    handleShowDetailLayer(event) {
        event.preventDefault();
        const self = this;
        if (self.props.onShowDetailLayer) {
            self.props.onShowDetailLayer();
        }
    }

    getShortValuesString(values) {
        if (values.length > this.MAXITEMSSHOWED) {
            return values.slice(0, this.MAXITEMSSHOWED).join(', ') + '...';
        }
        else {
            return values.join(', ');
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.row.IDCONTENTORGANIZATIONLOG !== this.state.row.IDCONTENTORGANIZATIONLOG) {
            this.setState({ row: nextProps.row });
        }
    }

    render() {

        let listOldValues = this.state.row.OLDVALUES ? this.state.row.OLDVALUES.split(',') : [];
        let listNewValues = this.state.row.NEWVALUES ? this.state.row.NEWVALUES.split(',') : [];
        let typeNameOldValues;

        if (listOldValues.length > 0) {
            if (this.state.row.TYPENAME === 'Category ') {
                typeNameOldValues = <p>Subcategory: </p>
            } else if (this.state.row.TYPENAME === 'Subcategory') {
                typeNameOldValues = <p>Keyword: </p>
            } else if (this.state.row.TYPENAME === 'Keyword') {
                typeNameOldValues = <p>Subcategory: </p>
            }
        }


        let actionName;

        if (this.state.row.ACTIONNAME === 'New relation') {
            actionName = <span className="badge badge-alt badge-info">{this.state.row.ACTIONNAME}</span>;
        }
        else if (this.state.row.ACTIONNAME === 'New') {
            actionName = <span className="badge badge-alt badge-info">{this.state.row.ACTIONNAME}</span>;
        }
        else if (this.state.row.ACTIONNAME === 'Delete relation') {
            actionName = <span className="badge badge-alt badge-danger">{this.state.row.ACTIONNAME}</span>;
        }
        else if (this.state.row.ACTIONNAME === 'Modification') {
            actionName = <span className="badge badge-alt badge-warning">{this.state.row.ACTIONNAME}</span>;
        }
        else if (this.state.row.ACTIONNAME === 'Delete') {
            actionName = <span className="badge badge-alt badge-danger">{this.state.row.ACTIONNAME}</span>;
        }
        else if (this.state.row.ACTIONNAME === 'Modification relation') {
            actionName = <span className="badge badge-alt badge-success">{this.state.row.ACTIONNAME}</span>;
        }

        return (
            <tr onClick={this.handleShowDetailLayer.bind(this)}>
                <td>{typing.convertToDateShortMonthWithTime(this.state.row.DATE)}</td>
                <td>{this.state.row.USERNAME}</td>
                <td><p>{this.state.row.TYPENAME}:</p>
                    {this.state.row.NAMEENTITY}</td>
                <td>{typeNameOldValues}
                    {this.getShortValuesString(listOldValues)}</td>
                <td>{this.getShortValuesString(listNewValues)}</td>
                <td> {actionName} </td>
            </tr>
        );
    }

}
